/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetAdminProjectsQuery } from '../models/GetAdminProjectsQuery';
import type { GetAdminProjectsQueryResponse } from '../models/GetAdminProjectsQueryResponse';
import type { GetCurrentUserProfileQuery } from '../models/GetCurrentUserProfileQuery';
import type { GetCurrentUserProfileQueryResponse } from '../models/GetCurrentUserProfileQueryResponse';
import type { GetDocumentChangeFeedDocumentDiffQuery } from '../models/GetDocumentChangeFeedDocumentDiffQuery';
import type { GetDocumentChangeFeedDocumentDiffQueryResponse } from '../models/GetDocumentChangeFeedDocumentDiffQueryResponse';
import type { GetDocumentChangeFeedQuery } from '../models/GetDocumentChangeFeedQuery';
import type { GetDocumentChangeFeedQueryResponse } from '../models/GetDocumentChangeFeedQueryResponse';
import type { GetDocumentCommentDiffQuery } from '../models/GetDocumentCommentDiffQuery';
import type { GetDocumentCommentDiffQueryResponse } from '../models/GetDocumentCommentDiffQueryResponse';
import type { GetDocumentCommentsQuery } from '../models/GetDocumentCommentsQuery';
import type { GetDocumentCommentsQueryResponse } from '../models/GetDocumentCommentsQueryResponse';
import type { GetDocumentHistoryEntryDiffQuery } from '../models/GetDocumentHistoryEntryDiffQuery';
import type { GetDocumentHistoryEntryDiffQueryResponse } from '../models/GetDocumentHistoryEntryDiffQueryResponse';
import type { GetDocumentHistoryQuery } from '../models/GetDocumentHistoryQuery';
import type { GetDocumentHistoryQueryResponse } from '../models/GetDocumentHistoryQueryResponse';
import type { GetDocumentQuery } from '../models/GetDocumentQuery';
import type { GetDocumentQueryResponse } from '../models/GetDocumentQueryResponse';
import type { GetGlobalSettingsQuery } from '../models/GetGlobalSettingsQuery';
import type { GetGlobalSettingsQueryResponse } from '../models/GetGlobalSettingsQueryResponse';
import type { GetMaintenanceInfoQuery } from '../models/GetMaintenanceInfoQuery';
import type { GetMaintenanceInfoQueryResponse } from '../models/GetMaintenanceInfoQueryResponse';
import type { GetPageBootstrapQuery } from '../models/GetPageBootstrapQuery';
import type { GetPageBootstrapQueryResponse } from '../models/GetPageBootstrapQueryResponse';
import type { GetPersonalAccessTokensQuery } from '../models/GetPersonalAccessTokensQuery';
import type { GetPersonalAccessTokensQueryResponse } from '../models/GetPersonalAccessTokensQueryResponse';
import type { GetProjectAccessRulesQuery } from '../models/GetProjectAccessRulesQuery';
import type { GetProjectAccessRulesQueryResponse } from '../models/GetProjectAccessRulesQueryResponse';
import type { GetPublicSettingsQuery } from '../models/GetPublicSettingsQuery';
import type { GetPublicSettingsQueryResponse } from '../models/GetPublicSettingsQueryResponse';
import type { GetRolesQuery } from '../models/GetRolesQuery';
import type { GetRolesQueryResponse } from '../models/GetRolesQueryResponse';
import type { GetUnreadCommentsQuery } from '../models/GetUnreadCommentsQuery';
import type { GetUnreadCommentsQueryResponse } from '../models/GetUnreadCommentsQueryResponse';
import type { GetUserQuery } from '../models/GetUserQuery';
import type { GetUserQueryResponse } from '../models/GetUserQueryResponse';
import type { GetUsersQuery } from '../models/GetUsersQuery';
import type { GetUsersQueryResponse } from '../models/GetUsersQueryResponse';
import type { GetWorkspaceQuery } from '../models/GetWorkspaceQuery';
import type { GetWorkspaceQueryResponse } from '../models/GetWorkspaceQueryResponse';
import type { SearchWorkspaceQuery } from '../models/SearchWorkspaceQuery';
import type { SearchWorkspaceQueryResponse } from '../models/SearchWorkspaceQueryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class QueriesService {
    /**
     * @returns GetPageBootstrapQueryResponse OK
     * @throws ApiError
     */
    public static queryGetPageBootstrapQuery({
        requestBody,
    }: {
        requestBody: GetPageBootstrapQuery,
    }): CancelablePromise<GetPageBootstrapQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetPageBootstrapQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetPublicSettingsQueryResponse OK
     * @throws ApiError
     */
    public static queryGetPublicSettingsQuery({
        requestBody,
    }: {
        requestBody: GetPublicSettingsQuery,
    }): CancelablePromise<GetPublicSettingsQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetPublicSettingsQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetCurrentUserProfileQueryResponse OK
     * @throws ApiError
     */
    public static queryGetCurrentUserProfileQuery({
        requestBody,
    }: {
        requestBody: GetCurrentUserProfileQuery,
    }): CancelablePromise<GetCurrentUserProfileQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetCurrentUserProfileQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetPersonalAccessTokensQueryResponse OK
     * @throws ApiError
     */
    public static queryGetPersonalAccessTokensQuery({
        requestBody,
    }: {
        requestBody: GetPersonalAccessTokensQuery,
    }): CancelablePromise<GetPersonalAccessTokensQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetPersonalAccessTokensQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetWorkspaceQueryResponse OK
     * @throws ApiError
     */
    public static queryGetWorkspaceQuery({
        requestBody,
    }: {
        requestBody: GetWorkspaceQuery,
    }): CancelablePromise<GetWorkspaceQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetWorkspaceQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns SearchWorkspaceQueryResponse OK
     * @throws ApiError
     */
    public static querySearchWorkspaceQuery({
        requestBody,
    }: {
        requestBody: SearchWorkspaceQuery,
    }): CancelablePromise<SearchWorkspaceQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/SearchWorkspaceQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetDocumentQueryResponse OK
     * @throws ApiError
     */
    public static queryGetDocumentQuery({
        requestBody,
    }: {
        requestBody: GetDocumentQuery,
    }): CancelablePromise<GetDocumentQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetDocumentQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetDocumentCommentsQueryResponse OK
     * @throws ApiError
     */
    public static queryGetDocumentCommentsQuery({
        requestBody,
    }: {
        requestBody: GetDocumentCommentsQuery,
    }): CancelablePromise<GetDocumentCommentsQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetDocumentCommentsQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetDocumentCommentDiffQueryResponse OK
     * @throws ApiError
     */
    public static queryGetDocumentCommentDiffQuery({
        requestBody,
    }: {
        requestBody: GetDocumentCommentDiffQuery,
    }): CancelablePromise<GetDocumentCommentDiffQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetDocumentCommentDiffQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetUnreadCommentsQueryResponse OK
     * @throws ApiError
     */
    public static queryGetUnreadCommentsQuery({
        requestBody,
    }: {
        requestBody: GetUnreadCommentsQuery,
    }): CancelablePromise<GetUnreadCommentsQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetUnreadCommentsQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetDocumentHistoryQueryResponse OK
     * @throws ApiError
     */
    public static queryGetDocumentHistoryQuery({
        requestBody,
    }: {
        requestBody: GetDocumentHistoryQuery,
    }): CancelablePromise<GetDocumentHistoryQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetDocumentHistoryQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetDocumentHistoryEntryDiffQueryResponse OK
     * @throws ApiError
     */
    public static queryGetDocumentHistoryEntryDiffQuery({
        requestBody,
    }: {
        requestBody: GetDocumentHistoryEntryDiffQuery,
    }): CancelablePromise<GetDocumentHistoryEntryDiffQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetDocumentHistoryEntryDiffQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetDocumentChangeFeedQueryResponse OK
     * @throws ApiError
     */
    public static queryGetDocumentChangeFeedQuery({
        requestBody,
    }: {
        requestBody: GetDocumentChangeFeedQuery,
    }): CancelablePromise<GetDocumentChangeFeedQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetDocumentChangeFeedQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetDocumentChangeFeedDocumentDiffQueryResponse OK
     * @throws ApiError
     */
    public static queryGetDocumentChangeFeedDocumentDiffQuery({
        requestBody,
    }: {
        requestBody: GetDocumentChangeFeedDocumentDiffQuery,
    }): CancelablePromise<GetDocumentChangeFeedDocumentDiffQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetDocumentChangeFeedDocumentDiffQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetUsersQueryResponse OK
     * @throws ApiError
     */
    public static queryGetUsersQuery({
        requestBody,
    }: {
        requestBody: GetUsersQuery,
    }): CancelablePromise<GetUsersQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetUsersQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetUserQueryResponse OK
     * @throws ApiError
     */
    public static queryGetUserQuery({
        requestBody,
    }: {
        requestBody: GetUserQuery,
    }): CancelablePromise<GetUserQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetUserQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetRolesQueryResponse OK
     * @throws ApiError
     */
    public static queryGetRolesQuery({
        requestBody,
    }: {
        requestBody: GetRolesQuery,
    }): CancelablePromise<GetRolesQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetRolesQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetAdminProjectsQueryResponse OK
     * @throws ApiError
     */
    public static queryGetAdminProjectsQuery({
        requestBody,
    }: {
        requestBody: GetAdminProjectsQuery,
    }): CancelablePromise<GetAdminProjectsQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetAdminProjectsQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetProjectAccessRulesQueryResponse OK
     * @throws ApiError
     */
    public static queryGetProjectAccessRulesQuery({
        requestBody,
    }: {
        requestBody: GetProjectAccessRulesQuery,
    }): CancelablePromise<GetProjectAccessRulesQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetProjectAccessRulesQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetGlobalSettingsQueryResponse OK
     * @throws ApiError
     */
    public static queryGetGlobalSettingsQuery({
        requestBody,
    }: {
        requestBody: GetGlobalSettingsQuery,
    }): CancelablePromise<GetGlobalSettingsQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetGlobalSettingsQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
    /**
     * @returns GetMaintenanceInfoQueryResponse OK
     * @throws ApiError
     */
    public static queryGetMaintenanceInfoQuery({
        requestBody,
    }: {
        requestBody: GetMaintenanceInfoQuery,
    }): CancelablePromise<GetMaintenanceInfoQueryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/queries/GetMaintenanceInfoQuery',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                429: `Too Many Requests`,
            },
        });
    }
}
